import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import googleLogo from '@/assets/images/pngs/Google-logo.png';
import Header from '@/components/layout/Header';
import { useNavigate } from 'react-router-dom';
import { ROUTES, TYPE_ACCOUNT } from '@/configs/constants';
import { Input } from '@/components/common/Input';
import { Button } from '@/components/common/Button';
import xLogo from '@/assets/images/pngs/x-logo.png';
import lineLogo from '@/assets/images/pngs/LINE-logo.png';
import passKeyIcon from '@/assets/images/pngs/pass-key.png';
import { flowResult } from 'mobx';
import { toastify } from '@/utils/toastify';

export default observer(function EditProfilePage() {
    // store
    const {
        authStore: { profile, updateMyInfo, getMyInfo }
    } = useStore();
    const navigate = useNavigate();
    const [userName, setUserName] = useState<string>(profile?.username || '');

    const registeredUserName = () => {
    };

    const goBack = () => {
        navigate(ROUTES.profile.href);
    };

    const checkIdSocial = (type: string) => {
        if (!profile) {
            return t('text.notLink');
        }
        const data = profile?.socialsAuth;
        switch (type) {
            case TYPE_ACCOUNT.GOOGLE:
                return data.find(e => e.type === TYPE_ACCOUNT.GOOGLE)?.email || t('text.notLink');
            case TYPE_ACCOUNT.TWITTER:
                const infoX = data.find(e => e.type === TYPE_ACCOUNT.TWITTER);
                return infoX?.name || infoX?.twitterId || t('text.notLink');
            case TYPE_ACCOUNT.LINE:
                const infoLine = data.find(e => e.type === TYPE_ACCOUNT.LINE);
                return infoLine?.name || infoLine?.lineSubId || t('text.notLink');
            case TYPE_ACCOUNT.PASSKEY:
                return data.find(e => e.type === TYPE_ACCOUNT.PASSKEY)?.email || t('text.notLink');
            default:
                return t('text.notLink');
        }
    };

    const updateUsername = async () => {
        const body = {
            username: userName
        };
        flowResult(updateMyInfo(body));
    };

    return (
        <div className='w-screen h-screen flex flex-col justify-start pt-[72px]'>
            <Header goBackFunction={goBack} title={t('text.editAccount')} />
            <div className='px-[16px] pt-[24px] pb-[12px] flex flex-col justify-between content-between h-full'>
                <div className='space-y-[16px]'>
                    <Input
                        placeholder='Username'
                        value={userName}
                        onChange={e => setUserName(e.target.value)}
                    />
                    <div className=' space-y-[4px]'>
                        <button className='w-full flex justify-start items-center bg-white px-[16px] py-[12px] rounded-[4px] shadow-lg shadow-shadow'>
                            <img src={googleLogo} alt='ggLogo' className='w-[34px] h-[34px]' />
                            <div className='ml-[16px] text-left'>
                                <p className='text-[15px] text-textAccountType font-medium'>Google</p>
                                <p className='text-[13px] text-textAccountName'>{checkIdSocial(TYPE_ACCOUNT.GOOGLE)}</p>
                            </div>
                        </button>
                        <button className='w-full flex justify-start items-center bg-white px-[16px] py-[12px] rounded-[4px] shadow-lg shadow-shadow'>
                            <img src={xLogo} alt='xLogo' className='w-[34px] h-[34px]' />
                            <div className=' ml-[16px] text-left'>
                                <p className='text-[15px] text-textAccountType font-medium'>Twiter</p>
                                <p className='text-[13px] text-textAccountName'>{checkIdSocial(TYPE_ACCOUNT.TWITTER)}</p>
                            </div>
                        </button>
                        <button className='w-full flex justify-start items-center bg-white px-[16px] py-[12px] rounded-[4px] shadow-lg shadow-shadow'>
                            <img src={lineLogo} alt='lineLogo' className='w-[34px] h-[34px]' />
                            <div className=' ml-[16px] text-left'>
                                <p className='text-[15px] text-textAccountType font-medium'>Line</p>
                                <p className='text-[13px] text-textAccountName'>{checkIdSocial(TYPE_ACCOUNT.LINE)}</p>
                            </div>
                        </button>
                        <button className='w-full flex justify-start items-center bg-white px-[16px] py-[12px] rounded-[4px] shadow-lg shadow-shadow'>
                            <img src={passKeyIcon} alt='passKeyLogo' className='w-[34px] h-[34px]' />
                            <div className='ml-[16px] text-left'>
                                <p className='text-[15px] text-textAccountType font-medium'>パスキー</p>
                                <p className='text-[13px] text-textAccountName'>{checkIdSocial(TYPE_ACCOUNT.PASSKEY)}</p>
                            </div>
                        </button>
                    </div>
                </div>
                <Button onClick={updateUsername} disabled={userName === profile?.username || !userName} variant='main' className='w-full '>{t('text.save')}</Button>
            </div>
        </div>
    );
});
